import { render, staticRenderFns } from "./CollectionMagazineNameMarcTable.vue?vue&type=template&id=80d62306&"
import script from "./CollectionMagazineNameMarcTable.vue?vue&type=script&lang=ts&"
export * from "./CollectionMagazineNameMarcTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports